import { render, staticRenderFns } from "./stockoutChanges_index.vue?vue&type=template&id=01a0c090&scoped=true&"
import script from "./stockoutChanges_index.vue?vue&type=script&lang=js&"
export * from "./stockoutChanges_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0c090",
  null
  
)

export default component.exports